import { FINANCIAL_SOLUTION } from '../actions';

const INIT_STATE = {
    id: null,
    num_credito: null,
};

const financialSolutionReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FINANCIAL_SOLUTION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default financialSolutionReducer;
